"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.skip_left = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const skip_left = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'skip-left-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L10.0607 10L13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967C13.2374 5.17678 12.7626 5.17678 12.4697 5.46967L8.46967 9.46967C8.17678 9.76256 8.17678 10.2374 8.46967 10.5303L12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303Z', fill: '#4B5563' }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.5 14.75C7.91421 14.75 8.25 14.4142 8.25 14L8.25 6C8.25 5.58579 7.91421 5.25 7.5 5.25C7.08579 5.25 6.75 5.58579 6.75 6L6.75 14C6.75 14.4142 7.08579 14.75 7.5 14.75Z', fill: '#4B5563' })));
};
exports.skip_left = skip_left;
